import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const nav = useNavigate();
  const { exchangeSessionId } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match?.[1];

    if (!sessionId) {
      nav("/app", { replace: true });
      return;
    }

    (async () => {
      try {
        const user = await exchangeSessionId(sessionId);
        // Clear the hash before navigating
        window.history.replaceState(null, "", window.location.pathname);
        nav("/app", { replace: true, state: { user } });
      } catch (e) {
        setError(e?.response?.data?.detail || "Auth exchange failed");
        setTimeout(() => nav("/login", { replace: true }), 2500);
      }
    })();
  }, [exchangeSessionId, nav]);

  return (
    <div className="min-h-screen grid place-items-center bg-[#0a192f] text-white">
      <div className="text-center">
        <div className="w-8 h-8 border-2 border-emerald-400 border-t-transparent rounded-full animate-spin mx-auto" />
        <p className="mt-4 text-sm text-slate-300">
          {error ? error : "Signing you in..."}
        </p>
      </div>
    </div>
  );
}
